// extracted by mini-css-extract-plugin
export default {"icon":"FileType_icon__2cWvV"};